module.exports = __webpack_public_path__ + "static/invoice_template.97f16729.png";